import React from 'react';
import { Typography, Link } from '@hpstellar/core/visId';
import useChat from '../../../hooks/useChat';
import { Helpers } from '../../../core/src/helpers';
import useUserData from '../../../hooks/useUserData';

import './call-center.less';

export default ({ title = 'Need help? Contact us now' }) => {
    const linkProps = {
        fontWeight: 700,
        theme: 'dark',
        tabindex: 0,
    };
    const { openChat } = useChat();
    const { userData } = useUserData();
    const { profileData } = userData || {};
    const { labels } = profileData || {};
    const { customerCarePhone } = labels || {};
    return (
        <div className="call-center">
            <Typography variant="subtitle" tag="h4" className="title-text">
                {title}
            </Typography>
            <div className="support-info">
                <div className="support-image">
                    <img
                        src="//www.hp.com/us-en/shop/app/assets/images/uploads/prod/lpchat-square1606770930108674.png"
                        alt="hp alt label"
                    />
                </div>
                <div className="support-links">
                    <Link {...linkProps} onClick={openChat} style={{ cursor: 'pointer' }}>{`Chat with us`}</Link>
                    <Link
                        {...linkProps}
                        to="/us-en/shop/SendEmailView?catalogId=10051&amp;langId=-1&amp;storeId=10151"
                        target="_blank"
                    >{` Send us an email`}</Link>
                    {customerCarePhone && (
                        <span>
                            {`Call `}
                            <span
                                dangerouslySetInnerHTML={Helpers.createMarkup(Helpers.decodeHtml(customerCarePhone))}
                            />
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};
